import { AccountModal } from '@ui/components/AccountModal';
import { FaqModal } from '@ui/components/Faq';
import { NftClaimDrawer, NftDetailDrawer } from '@ui/components/NFTCard';
import { VaultDetailDrawer } from '@ui/views/Vno/ReservoirAndFountain';
import NextProgress from 'nextjs-progressbar';

import {
  TransactionDetailDrawer,
  TransactionHistoryDrawer,
} from './TransactionHistoryDrawer';
import { TransakModal } from './TransakModal';
import { WalletModal } from './Wallet';

export const GlobalComponents = () => {
  return (
    <>
      <NextProgress />
      <WalletModal />
      <AccountModal />
      <VaultDetailDrawer />
      <FaqModal />
      <NftDetailDrawer />
      <NftClaimDrawer />
      <TransactionHistoryDrawer />
      <TransactionDetailDrawer />
      <TransakModal />
    </>
  );
};
